import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { HardwareTest } = await import('./index');
    return {
        Component: HardwareTest,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
